// src/components/Chat/Message/Chart/LineChartComponent.tsx
import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip as TooltipsChart,
  ResponsiveContainer,
  Legend,
} from "recharts";
import { Typography } from "@mui/material";

const LineChartComponent: React.FC<{
  data: Array<{ label: string; [key: string]: number | string }>;
  name: string;
  theme: any;
}> = ({ data, name, theme }) => {
  const lineKeys = Object.keys(data[0]).filter((key) => key !== "label");

  const getColor = (index: number) => {
    const colors = [
      theme.palette.primary.main,
      theme.palette.secondary.main,
      theme.palette.success.main,
      theme.palette.error.main,
      theme.palette.info.main,
      theme.palette.warning.main,
    ];
    return colors[index % colors.length];
  };

  return (
    <>
      <Typography sx={{ mb: 2, width: "100%", textAlign: "center" }}>
        {name}
      </Typography>
      <ResponsiveContainer width="100%" height={240}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke={theme.palette.divider} />
          <XAxis
            dataKey="label"
            tick={{
              fontFamily: theme.typography.fontFamily,
              fontSize: theme.typography.body2.fontSize,
              fill: theme.palette.text.primary,
            }}
          />
          <YAxis
            tick={{
              fontFamily: theme.typography.fontFamily,
              fontSize: theme.typography.body2.fontSize,
              fill: theme.palette.text.primary,
            }}
          />
          <TooltipsChart
            contentStyle={{
              fontFamily: theme.typography.fontFamily,
              fontSize: theme.typography.body2.fontSize,
              backgroundColor: theme.palette.background.paper,
              color: theme.palette.text.primary,
            }}
            itemStyle={{
              fontFamily: theme.typography.fontFamily,
              fontSize: theme.typography.body2.fontSize,
            }}
            labelStyle={{
              color: theme.palette.text.primary,
            }}
            cursor={{ fill: theme.palette.action.hover }}
          />
          <Legend
            wrapperStyle={{
              fontFamily: theme.typography.fontFamily,
              fontSize: theme.typography.body2.fontSize,
            }}
          />
          {lineKeys.map((key, index) => (
            <Line
              key={key}
              type="monotone"
              dataKey={key}
              name={key}
              stroke={getColor(index)}
              strokeWidth={2}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </>
  );
};

export default LineChartComponent;
